// extracted by mini-css-extract-plugin
export default {"list__error":"styes_list__error__WrAUg"};